import React, { useEffect } from "react";
import { useRouteMatch, Redirect, Route, Switch } from "react-router-dom";

import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import { useDispatch } from "services/redux/rootReducer";
import getAllTags from "../actions/set/update/get.getAllTags";
import TagEditorPage from "../screens/tagEdit";
import { TagType } from "features/shared/types/tag";
import getAllArticles from "features/article/actions/update/get.getAllArticles";

const TagRouter: React.FC = () => {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();

    const defaultDisplay = () => {
        return <Redirect to={`${path}/category`} />;
    };

    useEffect(() => {
        let unsubscribers: Array<() => void> = [];

        unsubscribers.push(dispatch(getAllTags()));
        unsubscribers.push(dispatch(getAllArticles()));

        return () => {
            unsubscribers.forEach((unsubscriberFn) => unsubscriberFn());
        };
    }, [dispatch]);

    return withAdminNavbar(
        <Switch>
            <Route exact path={path}>
                {defaultDisplay}
            </Route>
            <Route exact path={`${path}/category`}>
                <TagEditorPage tagType={TagType.Category} />
            </Route>
            <Route exact path={`${path}/supplier`}>
                <TagEditorPage tagType={TagType.Supplier} />
            </Route>
            <Route exact path={`${path}/application`}>
                <TagEditorPage tagType={TagType.Application} />
            </Route>
            <Route exact path={`${path}/process`}>
                <TagEditorPage tagType={TagType.Process} />
            </Route>
            <Route exact path={`${path}/custom`}>
                <TagEditorPage tagType={TagType.Custom} />
            </Route>
        </Switch>
    );
};

export default TagRouter;
